<template>
  <div class="card__scroller">
    <AppSimplebar
      v-bind="{ offsetMarginX, offsetMarginY }"
      data-simplebar-auto-hide="false"
    >
      <slot />
    </AppSimplebar>
  </div>
</template>

<script>
export default {
  name: "CardScroller",

  props: {
    offsetMarginX: {
      type: [Number, String],
      default: 0,
      require: false
    },
    offsetMarginY: {
      type: [Number, String],
      default: 0,
      require: false
    }
  }
};
</script>

<style lang="scss">
.card__scroller {
  padding: 0;
  width: calc(100% + 40px);
  overflow: auto;
  padding: 0;
  margin: 0 -20px;

  &:after,
  &:before {
    content: "";
    position: absolute;
    display: block;
    height: 100%;
    width: 30px;
    top: 0;
    z-index: 1;
    border-radius: 5px;
  }

  &:after {
    background: gradient(#10393b, #10393b, to left, 1, 0);
    right: 0;
  }

  &:before {
    background: gradient(#10393b, #10393b, to right, 1, 0);
    left: 0;
  }
}
</style>
